import { createLeadServices,
  updateLeadService,
  getAllLeads,
getDeletedLeadServices,
searchLeadServices,
getLeadsById,
searchLeadReportServices,
getDeleteNoteServices} from '../../services/leadServices';
import {
    START_LOADING,
    STOP_LOADING
} from "./actionTypes"
import { openSessionTimeoutModal } from './sessionTimeOutActions';

export const getAllLeadsAction = (page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getAllLeads(page, size, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'ALL_LEADS_SUCCESS', payload: response });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'ALL_LEADS_FAILURE', payload: error || 'All Leads service failed. Please try again.' });
    }
  }
};

export const getLeadsByIdAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getLeadsById(id, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GETBYID_LEADS_SUCCESS', payload: response });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GETBYID_LEADS_FAILURE', payload: error || 'Get By Id Leads service failed. Please try again.' });
    }
  }
};

// export const getMyLeads = (ownerId) => async (dispatch, getState) => {
//   try {
//     dispatch({ type: START_LOADING, service: 'MY_LEADS' });
//     const token = getState().auth.token || sessionStorage.getItem("token");;
//     const response = await leadServices.getMyLeads(ownerId, token);
//     dispatch({ type: STOP_LOADING, service: 'MY_LEADS' });
//     dispatch({ type: 'MY_LEADS_SUCCESS', payload: response });
//   } catch (error) {
//     if(error?.includes("403")) {
//       dispatch(openSessionTimeoutModal());
//     } else {
//       dispatch({ type: STOP_LOADING, service: 'MY_LEADS' });
//       dispatch({ type: 'MY_LEADS_FAILURE', payload: error || 'My Leads service failed. Please try again.' });
//     }
//   }
// };

export const createLeadAction = (formData,onSuccess, onError) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await createLeadServices(formData, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'CREATE_LEAD_SUCCESS', payload: response });
     if (onSuccess) onSuccess(response);
  } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'CREATE_LEAD_FAILURE', payload: error || 'Create Lead service failed. Please try again.' });
       let errorMessage = '';
    let errorDetails = null;
    if (error?.errors && Array.isArray(error.errors) && error.errors.length > 0) {
      const firstError = error.errors[0];
      errorMessage = firstError.errorMessage;

      // Include target information if needed
      if (firstError.target) {
        errorDetails = {
          message: firstError.errorMessage,
          target: firstError.target
        };
      }
    } else if (error?.message) {
      errorMessage = error.message;
    }

    // Throw error with details
    const errorToThrow = new Error(errorMessage);
    if (errorDetails) {
      errorToThrow.details = errorDetails;
    }
    // throw errorToThrow;
       if (onError) onError(errorMessage);

  }
};

export const searchLeadAction = (formData,page= 0,size=5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await searchLeadServices(formData,page,size, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'SEARCH_LEAD_SUCCESS', payload: response });
  } catch (error) {
    if (error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'SEARCH_LEAD_FAILURE', payload: error || 'Search Lead service failed. Please try again.' });
    }
  }
};


export const updateLead = (formData,onSuccess, onError) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");;
    const response = await updateLeadService(formData, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

    dispatch({ type: 'UPDATE_LEAD_SUCCESS', payload: response });
      if (onSuccess) onSuccess(response);
  } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'UPDATE_LEAD_FAILURE', payload: error || 'Update Lead service failed. Please try again.' });
       let errorMessage = '';
    let errorDetails = null;
    if (error?.errors && Array.isArray(error.errors) && error.errors.length > 0) {
      const firstError = error.errors[0];
      errorMessage = firstError.errorMessage;

      // Include target information if needed
      if (firstError.target) {
        errorDetails = {
          message: firstError.errorMessage,
          target: firstError.target
        };
      }
    } else if (error?.message) {
      errorMessage = error.message;
    }

    // Throw error with details
    const errorToThrow = new Error(errorMessage);
    if (errorDetails) {
      errorToThrow.details = errorDetails;
    }
    // throw errorToThrow;
       if (onError) onError(errorMessage);
  }
};

// export const openCreateLeadModal = () => ({
//   type: OPEN_CREATE_LEAD_MODAL,
// });

// export const closeCreateLeadModal = () => ({
//   type: CLOSE_CREATE_LEAD_MODAL,
// });

// export const openUpdateLeadModal = (id) => async (dispatch) => {
//   dispatch({ type:OPEN_UPDATE_LEAD_MODAL, payload: id });
// };

export const getDeletedLeadAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getDeletedLeadServices(id, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_DELTED_LEAD_SUCCESS', payload: response });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_DELTED_LEAD_FAILURE', payload: error || 'Delete Leads service failed. Please try again.' });
    }
  }
};


export const getDeleteNoteAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getDeleteNoteServices(id, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_DELTED_NOTE_SUCCESS', payload: response });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_DELTED_LEAD_FAILURE', payload: error || 'Delete Leads service failed. Please try again.' });
    }
  }
};
export const searchLeadReportAction = (
  formData,
  page = 0,
  size = 5,
  sortField = "",
  sortOrder = "asc"
) => async (dispatch, getState) => {
  try {
    dispatch({ type: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");

    const response = await searchLeadReportServices(
      formData,
      token,
      page,
      size,
      sortField,
      sortOrder
    );

    dispatch({ type: 'SEARCH_LEAD_REPORT_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: 'SEARCH_LEAD_REPORT_FAILURE', payload: error.message });
  } finally {
    dispatch({ type: 'STOP_LOADING' });
  }
};

